
import { Circle } from "lucide-react";
import React from "react";

const whyChooseUsData = [
    { title: "Services for Visas in All E-Visa Countries" },
    { title: "40 years of expertise in processing visas" },
    { title: "150+ Locations Internationally" },
    { title: "End-to-End Visa Support" },
    { title: "Document Security & Confidentiality" },
    { title: "Payment Security" },
];

export function WhyChooseUs() {
    return (
      <div>
        <div className="mb-6">
          <h2 className="text-3xl font-bold">
  What makes us the right choice? We are Amazing, that&apos;s why!
</h2>

        </div>
        <ul className="space-y-3">
          {whyChooseUsData.map((item, index) => (
            <li key={index} className="flex items-center">
                <Circle size={16} className="text-primary fill-current mr-3 flex-shrink-0" />
                <span className="text-lg">{item.title}</span>
            </li>
          ))}
        </ul>
      </div>
    );
}
